const CheckCircleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="22" viewBox="0 0 24 24" width="22">
    <path d="M12 1a11 11 0 1 0 11 11A11.013 11.013 0 0 0 12 1zm0 20a9 9 0 1 1 9-9 9.01 9.01 0 0 1-9 9z" />
    <path d="m16.324 8.763-5.294 4.853-2.323-2.323a1 1 0 1 0-1.414 1.414l3 3a1 1 0 0 0 1.383.03l6-5.5a1 1 0 1 0-1.352-1.474z" />
  </svg>
);

export default CheckCircleIcon;
